<template>
  <v-card
    outlined class="bordered-card" :class="[{
      'finished': isStatusFinished
    }]"
    :disabled="isStatusFinished"
  >
    <!-- Header -->
    <v-container fluid>
      <v-row align="center" class="ma-0">
        <v-chip small class="white--text" :color="mainColor">#{{ item.nrProgramacaoAbate }}</v-chip>
        <v-spacer />
        <span class="status-text">{{ item.cdStatusProgramacaoAbate | formatStatusDisplay(item) }}</span>
      </v-row>
    </v-container>
    <!-- Content -->
    <v-container>
      <v-sheet color="white">
        <v-container fluid>
          <v-row>
            <v-col cols="6" class="py-1">
              <div class="d-flex flex-column">
                <span class="info-text">Início</span>
                <span class="info-value">{{ item.dtInicioAbate | formatDate }}</span>
              </div>
            </v-col>
            <v-col cols="6" class="py-1">
              <div class="d-flex flex-column">
                <span class="info-text">Término</span>
                <span class="info-value">{{ item.dtFimAbate | formatDate }}</span>
              </div>
            </v-col>
            <v-col cols="12" class="py-1">
              <div class="d-flex flex-column">
                <span class="info-text">Total de Animais Alocados</span>
                <span class="info-value">{{ item.qtDemanda || "Não informado" }}</span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-container>
    <!-- Actions -->
    <v-container fluid>
      <v-row class="ma-0">
        <v-col cols="4" class="py-1">
          <ProgrammingHistoryStatsDialog
            :list-history-stats="
            item.lista_status_historico"
            :cd-status-programacao="item.cdStatusProgramacaoAbate"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" block outlined class="view-btn" :loading="loading">
                <v-icon small>fas fa-history</v-icon>
              </v-btn>
            </template>
          </ProgrammingHistoryStatsDialog>
        </v-col>
        <v-col cols="4" class="py-1">
          <SlaughterScheduleCancelDialog
            :item="item"
            @confirmed="onCancelConfirmed"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" block outlined class="view-btn" :loading="loading">
                <v-icon small>fas fa-trash</v-icon>
              </v-btn>
            </template>
          </SlaughterScheduleCancelDialog>
        </v-col>
        <v-col cols="4" class="py-1">
          <SlaughterScheduleEditDialog
            :item="item"
            @updated="onUpdated"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" block outlined class="view-btn" :loading="loading">
                <v-icon small>fas fa-edit</v-icon>
              </v-btn>
            </template>
          </SlaughterScheduleEditDialog>
        </v-col>
        <v-col cols="12" class="py-1">
          <v-btn block outlined @click="onViewClick" class="view-btn" :loading="loading">Visualizar</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import moment from "moment"
import {mapActions, mapState} from "vuex"
import {SlaughterProgrammingStepsEventBus} from "@/modules/programacaoAbate/events"
import ProgrammingHistoryStatsDialog from "@/modules/programacaoAbate/components/WeekTab/ProgrammingHistoryStatsDialog"
import SlaughterScheduleCancelDialog from "@/modules/programacaoAbate/components/WeekTab/SlaughterScheduleCancelDialog"
import services from "@/http"
import * as types from "@/modules/programacaoAbate/store/mutation-types"
import SlaughterScheduleEditDialog from "@/modules/programacaoAbate/components/WeekTab/SlaughterScheduleEditDialog"
import {cloneDeep} from "lodash/lang";

const SLAUGHTER_SCHEDULE_STATUS = {
  1: "Informar demanda",
  2: "Alocar lotes",
  3: "Confirmar programação",
  4: "Informar turno de abate",
  5: "Carregamento confirmado",
  6: "Cancelado",
}

export default {
  name: "SlaughterScheduleCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    SlaughterScheduleEditDialog,
    SlaughterScheduleCancelDialog,
    ProgrammingHistoryStatsDialog,
  },
  data: () => ({
    loading: false,
  }),
  filters: {
    formatDate(value) {
      if (!value) return ""
      return moment(value).format("DD/MM")
    },
    formatStatusDisplay(value, item) {
      const dtFimAbate = moment(item.dtFimAbate)
      if (moment(moment.now()).isAfter(dtFimAbate.add(1, "day"))) {
        return "Finalizado"
      }
      
      if (value === 5 && !item.blChecklistPreenchidos) {
        return "Turnos parcialmente confirmados"
      }
      
      const status = SLAUGHTER_SCHEDULE_STATUS[value]
      if (!status) return ""
      return status
    },
  },
  methods: {
    onViewClick() {
      // const dateList = prepareDateList(this.item.dtInicioAbate, this.item.dtFimAbate)
      this.loading = true
      this.ActionLoadProgramacaoAbate(this.item.idProgramacaoAbate)
        .then((data) => {
          let status
          if (data.cdStatusProgramacaoAbate === 1)
            status = data.cdStatusProgramacaoAbate
          else status = data.cdStatusProgramacaoAbate - 1
          SlaughterProgrammingStepsEventBus.$emit("set-step", status)
        })
        .finally(() => (this.loading = false))
      // this.ActionChangeProgrammingSlaughterSelected(this.item)
      // this.ActionMontaListaDatas(dateList)
    },
    onCancelConfirmed() {
      let payload = {
        cdProgramacaoAbate: this.item.idProgramacaoAbate,
        cdStatusProgramacaoAbate: 6
      }
      return services.programacaoAbate.changeStatusProgramacao(payload).then(() => {
        this.$emit("deleted")
      })
    },
    onUpdated(slaughterSchedule) {
      const item = cloneDeep(this.item)
      item.dtInicioAbate = slaughterSchedule.dtInicioAbate
      item.dtFimAbate = slaughterSchedule.dtFimAbate
      this.$emit("updated", item)
    },
    ...mapActions("programacaoAbate", ["ActionLoadProgramacaoAbate"]),
  },
  computed: {
    isStatusFinished() {
      const dtFimAbate = moment(this.item.dtFimAbate)
      return moment(moment.now()).isAfter(dtFimAbate.add(1, "day"))
    },
    mainColor() {
      return this.isStatusFinished ? "#BDCCCA" : "#2BC1B6"
    },
  },
}
</script>
<style scoped lang="scss">
.bordered-card {
  border: 1px solid #e5e8e7;
  border-radius: 8px;
  
  &:not(.finished) {
    background: #f2f5f3 0 0 no-repeat padding-box;
  }
}

.view-btn {
  border: 1px solid #e5e8e7;
  border-radius: 4px;
  color: #10303d;
  width: 100%;
}

.status-text {
  text-align: right;
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
  color: #37565c;
  opacity: 1;
}

.info-text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #7b9596;
  opacity: 1;
}

.info-value {
  font: normal normal bold 20px/32px Roboto;
  letter-spacing: 0;
  color: #37565c;
  opacity: 1;
}
</style>